const cardHover = {
  '&:hover': {
    boxShadow: 'cardListHover',
    transition: 'box-shadow 0.3s ease, border-color 0.3s ease, transform 0.15s ease-out',
    textDecoration: 'none',
  },
  '&:active': {
    transform: 'scale(0.97)',
    boxShadow: 'none',
  },
};

const baseCarousel = {
  default: {
    background: 'white',
    borderRadius: 'textOnly',
    borderWidth: '2px 2px 2px 24px',
    borderStyle: 'solid',
    borderColor: 'orange.45',
    minWidth: '356px',
    minHeight: '92px',
    boxShadow: 'cardTextOnly',
  },
  imageWithText: {
    ...cardHover,
    background: 'white',
    borderRadius: 'card',
    minWidth: '220px',
    minHeight: '172px',
    boxShadow: 'cardList',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
};

const carousel = {
  products: {
    chart: baseCarousel,
    chartblog: baseCarousel,
    co: baseCarousel,
    edu: baseCarousel,
    scale: baseCarousel,
    spark: baseCarousel,
  },
};

export type CardCarouselVariantsType = 'default' | 'imageWithText';
export const cardCarouselVariants = Object.keys(baseCarousel) as CardCarouselVariantsType[];

export default carousel;
